import React, { useEffect, useRef, useState } from 'react';
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faClock, faAward, faLightbulb } from '@fortawesome/free-solid-svg-icons';

const About = () => {
    const [animatedElements, setAnimatedElements] = useState({});
    const observer = useRef(null);

    useEffect(() => {
        const observerInstance = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setAnimatedElements(prev => ({
                        ...prev,
                        [entry.target.id]: true
                    }));
                }
            });
        }, { threshold: 0.2 });

        observer.current = observerInstance;

        const elementsToObserve = [
            'about-image', 'about-header-h2', 'about-header-p', 'about-text',
            'core-value-1', 'core-value-2', 'core-value-3', 'core-value-4',
            'about-card-1', 'about-card-2', 'about-card-3', 'about-card-4'
        ];

        elementsToObserve.forEach(id => {
            const element = document.getElementById(id);
            if (element) {
                observerInstance.observe(element);
            }
        });

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, []);

    return (
        <section id="about" className="about-section">
            <div className="about-container">
                <div className="about-flex">
                    <div
                        id="about-image"
                        className={`about-image ${animatedElements['about-image'] ? 'animate' : ''}`}
                    >
                        <img
                            src="https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                            alt="About Emkan"
                        />
                    </div>
                    <div className="about-right">
                        <div className="about-header">
                            <h2
                                id="about-header-h2"
                                className={animatedElements['about-header-h2'] ? 'animate' : ''}
                            >
                                About Emkan
                            </h2>
                            <p
                                id="about-header-p"
                                className={animatedElements['about-header-p'] ? 'animate' : ''}
                            >
                                Your trusted partner in financial excellence and business growth
                            </p>
                        </div>
                        <div className="about-content">
                            <div
                                id="about-text"
                                className={`about-text ${animatedElements['about-text'] ? 'animate' : ''}`}
                            >
                                <h3>Excellence in Financial Management</h3>
                                <p><strong>Emkan</strong> is a UAE-based financial services firm providing comprehensive accounting, bookkeeping, and tax compliance solutions for businesses of all sizes.</p>
                                <p>With over <strong>5 years of combined experience</strong>, our qualified team ensures accuracy, efficiency, and regulatory compliance in all financial matters.</p>
                                <p><strong>Mission:</strong> Empower businesses with reliable and innovative financial solutions that drive growth.</p>
                                <div className="core-values">
                                    <div id="core-value-1" className={animatedElements['core-value-1'] ? 'animate' : ''}><span>✔</span> IFRS Compliant</div>
                                    <div id="core-value-2" className={animatedElements['core-value-2'] ? 'animate' : ''}><span>✔</span> UAE Tax Expertise</div>
                                    <div id="core-value-3" className={animatedElements['core-value-3'] ? 'animate' : ''}><span>✔</span> Client-Focused</div>
                                    <div id="core-value-4" className={animatedElements['core-value-4'] ? 'animate' : ''}><span>✔</span> Innovative Solutions</div>
                                </div>
                            </div>
                            <div className="about-cards">
                                <div id="about-card-1" className={`about-card ${animatedElements['about-card-1'] ? 'animate' : ''}`}>
                                    <FontAwesomeIcon icon={faUserTie} />
                                    <h5>Expert Team</h5>
                                    <p>Certified professionals with years of experience</p>
                                </div>
                                <div id="about-card-2" className={`about-card ${animatedElements['about-card-2'] ? 'animate' : ''}`}>
                                    <FontAwesomeIcon icon={faClock} />
                                    <h5>Timely Delivery</h5>
                                    <p>Accurate and punctual financial reports</p>
                                </div>
                                <div id="about-card-3" className={`about-card ${animatedElements['about-card-3'] ? 'animate' : ''}`}>
                                    <FontAwesomeIcon icon={faAward} />
                                    <h5>Recognized Excellence</h5>
                                    <p>Awards and recognitions in financial services</p>
                                </div>
                                <div id="about-card-4" className={`about-card ${animatedElements['about-card-4'] ? 'animate' : ''}`}>
                                    <FontAwesomeIcon icon={faLightbulb} />
                                    <h5>Innovative Solutions</h5>
                                    <p>Smart strategies tailored to your business needs</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;